var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmpbk_lght white--text",attrs:{"id":"home"}},[_c('auth'),_c('v-main',[_c('xtabs')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }